import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export function ExistingCustomerHint({ data, onUse, onLink, linkedId, className = "col-span-2" }) {
  const [hits, setHits] = useState([]);
  const { kunde_name = "", kunde_adresse = "", kunde_plz = "", telefon = "", email = "" } = data;

  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/kunden/duplikate/check", { kunde_name, kunde_adresse, kunde_plz, telefon, email })
        .then((r) => setHits(r.data || []))
        .catch(() => setHits([]));
    }, 400);
    return () => clearTimeout(t);
  }, [kunde_name, kunde_adresse, kunde_plz, telefon, email]);

  if (!hits.length) return null;
  return (
    <div className={`${className} rounded-md border border-amber-300 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-700 p-3 text-sm space-y-2`} data-testid="existing-customer-hint">
      <div className="flex items-center gap-2 font-medium text-amber-800 dark:text-amber-300">
        <AlertTriangle className="h-4 w-4" /> Diesen Kunden gibt es möglicherweise schon
      </div>
      {hits.map((h, i) => (
        <div key={i} className="flex items-start justify-between gap-3" data-testid={`existing-customer-${i}`}>
          <div className="min-w-0">
            <div className="font-medium truncate">{h.kunde_name || "– ohne Name –"}</div>
            <div className="text-xs text-muted-foreground">
              {[h.strasse, [h.kunde_plz, h.kunde_ort].filter(Boolean).join(" ")].filter(Boolean).join(", ")}
              {" · "}{h.projects} Projekt(e){h.anmeldungen ? `, ${h.anmeldungen} Anmeldung(en)` : ""}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1 shrink-0">
            <button type="button" onClick={() => onUse(h)} className="text-xs text-primary underline" data-testid={`existing-customer-use-${i}`}>
              Daten übernehmen
            </button>
            {onLink && h.project_refs?.map((p, j) => (
              <button key={p.id} type="button" onClick={() => onLink(p.id)} disabled={linkedId === p.id}
                className="text-xs text-primary underline disabled:no-underline disabled:text-emerald-600" data-testid={`existing-customer-link-${i}-${j}`}>
                {linkedId === p.id ? "Verknüpft ✓" : `Mit ${p.project_type === "waermepumpe" ? "WP" : "PV"}-Projekt verknüpfen`}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
